import type { FC } from 'react';
import { useGetQuestionnaireTemplateById } from 'src/hooks/queries/questionnaire-template/useGetQuestionnaireTemplateById';

type Props = {
  questionnaireTemplateId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ questionnaireTemplateId }) => {
  if (!questionnaireTemplateId) {
    throw new Error('Missing questionnaireTemplateId param');
  }
  const { data } = useGetQuestionnaireTemplateById(questionnaireTemplateId);

  return <>{data?.questionnaire_template?.Title || ''}</>;
};

export default Breadcrumb;
